var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"mr-2",attrs:{"type":"danger","size":"sm"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-trash fa-fw"}),_vm._v("Eliminar\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }